import { getDriver } from "@/tours/driverInstance";
import router from '@/router'
import demoImgUrl from '@/assets/img/tour/bizLocationSample.png';

export function bizLocationListSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dlist.total"]'),
      popover: {
        title: "목록 보기 설정",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
        <ul class="pb-0 ps-3">
          <li>현재 조회 가능한 <b>전체 건수</b>를 보여줍니다.</li>
          <li>‘페이지당’ 드롭다운으로 한 페이지에 표시할 행 수를 바꿀 수 있습니다.</li>
        </ul>
        `,
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dlist.total"]'),
    },
    {
      element: () => q('[data-tour="dlist.search"]'),
      popover: {
        title: "업무장소 검색",
        side: "left",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>검색할 <b>장소명/URN/주소</b>를 입력합니다.</li>
          <li>검색 시 1페이지부터 다시 보여주며, <b>빈 칸</b>으로 검색하면 <b>전체 목록</b>을 조회합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dlist.search"]'),
    },
    {
      element: () => q('[data-tour="dlist.table"]'),
      popover: {
        title: "데이터 조회",
        side: "top",
        align: "center",
        description: `
        <ul class="pb-0 ps-3">
          <li>테이블 행을 클릭하면 <b>상세 정보 화면</b>으로 이동합니다.</li>
          <li>여기서 데이터 수정이나 삭제를 진행할 수 있습니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dlist.table"]'),
    },
    {
      element: () => q('[data-tour="dlist.create"]'),
      popover: {
        title: "업무장소 등록",
        side: "left",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>업무장소를 <b>등록하는 화면</b>으로 이동합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dlist.create"]'),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>업무장소 등록화면</b>으로 이동하시겠어요?
          </div>
            <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
              <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
              <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
                이동
              </button>
            </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'BizLocationCreate' ,query: { tour: 'true', view: 'create' } });
          });
      }
    },
  ];
}


export function bizLocationCreateSteps(focusIntoView) {
  const q = (sel) => document.querySelector(sel);
  return [
    {
      element: () => q('[data-tour="dcreate.left"]'),
      popover: {
        title: "상세정보 설정",
        side: "right",
        align: "start",
        popoverClass: 'driver-theme-bs popover-offset-r',
        description: `
         <div class="ds-tip" style="margin-bottom:32px;">
          <div class="item"><span class="num">1</span><div class="txt">
            <div class="tit">대표 이미지</div>
            <div class="desc">
              업무장소를 시각적으로 구분할 수 있는 사진을 등록합니다. (선택 항목)<br/>
              예) 건물 외관, 층별 안내 사진, 내부 구역 전경 등<br/>
              ※ JPG/PNG 형식, 10MB 이하 권장
            </div>
          </div></div>

          <div class="item"><span class="num">2</span><div class="txt">
            <div class="tit">업무장소명</div>
            <div class="desc">
              장소를 쉽게 식별할 수 있는 이름을 입력합니다.<br/>
              예) <b>본사 1층 로비</b>, <b>2동 생산라인 A구역</b>, <b>물류센터 출고장</b>
            </div>
          </div></div>

          <div class="item"><span class="num">3</span><div class="txt">
            <div class="tit">URN</div>
            <div class="desc">
              EPCIS에서 사용하는 고유 식별자(URN: Uniform Resource Name)를 입력합니다.<br/>
              조직·위치·세부코드 체계를 반영하여 관리되며, 다른 장소와 중복되지 않도록 유의하세요.<br/>
              예) urn:epc:id:sgln:8808123456.21.0
            </div>
          </div></div>

          <div class="item"><span class="num">4</span><div class="txt">
            <div class="tit">주소</div>
            <div class="desc">
              업무장소의 실제 도로명 주소를 입력합니다.<br/>
              예) <b>서울특별시 강남구 테헤란로 123</b>
            </div>
          </div></div>

          <div class="item"><span class="num">5</span><div class="txt">
            <div class="tit">위도 / 경도</div>
            <div class="desc">
              지도에서 해당 장소를 클릭하면 자동 입력됩니다.<br/>
              ※ 다시 클릭하면 새 좌표로 갱신됩니다.
            </div>
          </div></div>

          <div class="item"><span class="num">6</span><div class="txt">
            <div class="tit">비고</div>
            <div class="desc">
              업무장소에 대한 추가 설명이나 특이사항을 자유롭게 기재합니다.<br/>
              예) <b>방문객 안내 데스크 옆 / 출입 시 보안카드 필요 / 담당자: 홍길동(내선 1234)</b>
            </div>
          </div></div>
        </div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="auto-input" class="driver-popover-custom-btn driver-popover-btn">
              다음
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));
        const typeInto = async (el, text, delay = 25) => {
          if (!el) return;
          el.focus();
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          for (const ch of text) {
            el.value += ch;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            await sleep(delay);
          }
          el.blur();
        };

        const scopeLeft = '[data-tour="dcreate.left"]';
        const $name    = document.querySelector(`${scopeLeft} input[placeholder="예: 본사 1층 로비"]`);
        const $urn     = document.querySelector(`${scopeLeft} input[placeholder^="예: urn:epc"]`);
        const $address = document.querySelector(`${scopeLeft} input[placeholder="도로명 주소"]`);
        const $memo    = document.querySelector(`${scopeLeft} textarea[placeholder="메모를 입력하세요."]`);

        const setDemoImage = async (url) => {
          const res = await fetch(url);
          const blob = await res.blob();
          const name = (url.split('/').pop() || 'demo.jpg');
          const file = new File([blob], name, { type: blob.type });
          window.dispatchEvent(new CustomEvent('tour:setImage', { detail: { file, blob, name } }));
        };

        const btn = document.querySelector('#auto-input');
        if (!btn) return;

        // ✅ 기존에 붙은 모든 핸들러 제거(Driver의 기본 next 포함 가능성) + 대체
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);

        let running = false; // 재진입 가드

        const run = async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (running) return;          // 이미 실행 중이면 무시
          running = true;

          // UI 잠금
          const prevText = clone.textContent;
          clone.disabled = true;
          clone.classList.add('is-busy');

          try {
            await sleep(50);
            await setDemoImage(demoImgUrl);
            await typeInto($name,    '본사 1층 로비', 10);
            await typeInto($urn,     'urn:epc:id:sgln:8808123456.21.0', 10);
            await typeInto($address, '서울특별시 강남구 테헤란로 123', 10);
            await typeInto($memo,    '현관 근처, 내방객 안내 데스크 옆', 10);

            await sleep(1700);
            drv.moveNext();            // 완료 후 다음 스텝
          } finally {
            // 필요 시 다시 활성화 (다음 스텝으로 넘어가니 의미 없으면 생략 가능)
            clone.disabled = false;
            clone.textContent = prevText;
            clone.classList.remove('is-busy');
            running = false;
          }
        };

        // 한 개의 리스너만 등록
        clone.addEventListener('click', run);
      }
    },
    {
      element: () => q('[data-tour="dcreate.right"]'),
      popover: {
        title: "위치정보 설정",
        side: "left",
        align: "center",
        description: `
        <ul class="pb-0 ps-3"style="margin-bottom:32px;">
          <li>지도를 클릭하면 해당 위치의 <b>위도/경도</b>가 자동 입력됩니다.</li>
          <li>다시 클릭하면 새로운 좌표로 갱신됩니다.</li>
          <li>입력된 좌표는 업무장소의 실제 위치정보로 저장됩니다.</li>
        </ul>
        <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:end;">
          <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
          <button id="auto-map" class="driver-popover-custom-btn driver-popover-btn">
            다음
          </button>
        </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();

        const sleep = (ms) => new Promise(r => setTimeout(r, ms));

        // ✅ DOM 중앙 좌표로 네이티브 마우스 이벤트를 쏘는 방식
        const fireClickAtCenter = () => {
          const el = document.querySelector('.leaflet-container');
          if (!el) return;
          const rect = el.getBoundingClientRect();
          const x = rect.left + rect.width  / 2;
          const y = rect.top  + rect.height / 2;

          ['mousedown','mouseup','click'].forEach(type => {
            el.dispatchEvent(new MouseEvent(type, {
              bubbles: true,
              cancelable: true,
              view: window,
              clientX: x,
              clientY: y
            }));
          });
        };

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fireClickAtCenter();
          });
        });

        const btn = document.querySelector('#auto-map');
        if (btn) {
          const clone = btn.cloneNode(true);
          btn.replaceWith(clone); // 기존 리스너 제거
          clone.addEventListener('click', async (e) => {
            e.preventDefault();
            clone.disabled = true;
            await sleep(600);
            drv.moveNext();
          }, { once: true });
        }
      }
    },
    {
      element: () => q('[data-tour="dcreate.croods"]'),
      popover: {
        title: "좌표 설정",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>선택 된 좌표로 <b>위도/경도</b>가 설정됩니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.croods"]'),
    },
    {
      element: () => q('[data-tour="dcreate.save"]'),
      popover: {
        title: "저장하기",
        side: "top",
        align: "start",
        description: `
        <ul class="pb-0 ps-3">
          <li>해당 내용으로 데이터를 <b>저장</b>합니다.</li>
        </ul>
        `
      },
      onHighlightStarted: () => focusIntoView('[data-tour="dcreate.save"]'),
    },
    {
      element: null,
      popover: {
        title: "다음 가이드로 이동",
        side: "center",
        align: "center",
        description: `
          <div style="margin-bottom:32px;"><b>스캔장소 등록메뉴</b>로 이동하시겠어요?</div>
          <div class="driver-popover-footer" style="display:flex; gap:8px; justify-content:center;">
            <button type="button" class="driver-popover-prev-btn" style="display: block;">이전</button>
            <button id="go-register" class="driver-popover-next-btn driver-popover-btn">
              이동
            </button>
          </div>
        `,
        showButtons: []
      },
      onHighlighted: () => {
        const drv = getDriver();
        document.querySelector('#go-register')
          ?.addEventListener('click', () => {
            drv.destroy();
            router.push({ name: 'ReadPoints' ,query: { tour: 'true' } });
          });
      }
    },
  ];
}
